// Public: Hook for the responsive navigation stuff to show/hide
// the <nav> elements.
(function() {
  $(document).on('click', '[data-behavior="nav"]', function(evt) {
    evt.preventDefault();
    return $('header').toggleClass('showNav');
  });

}).call(this);
